// This is fairly generic - I wanted to put this into @common, but not sure where it should go
// Taken from libs>marketing>mfe>src>hooks>useResponsiveBreakpoint.ts

import useWindowWidth from './useWindowWidth.js';

const MOBILE_BREAKPOINT = 600;

const useResponsiveBreakpoint = (breakpointWidth: number = MOBILE_BREAKPOINT): boolean => {
  const windowWidth = useWindowWidth();

  if (windowWidth === null) {
    return false;
  }

  return windowWidth <= breakpointWidth;
};

export default useResponsiveBreakpoint;
